module.exports = __webpack_public_path__ + "img/icon_jzhj.e6a82199.png";